import {h, Fragment} from "preact"
export default function RangeInput({ className, ...props }) {
    return <><span>$</span><input type="number" className={`ns-input-field ns-d-block ${className}`} {...props} /></>
}